// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"465cb994","453":"6b072cf9","817":"d2c1e18b"}[chunkId] + ".chunk.js";
};